// extracted by mini-css-extract-plugin
module.exports = {"tabContainer":"AdminGroupManagement_tabContainer_Jmm6W"};